import baseAxios from "axios";

export const BE_URL = process.env.REACT_APP_BE_URL || "";
export const FE_URL = process.env.REACT_APP_FE_URL || "";
export const PROD_URL = process.env.REACT_APP_PROD_URL || "";
export const FONT_API_KEY =
  process.env.REACT_APP_FONT_API_KEY ||
  "AIzaSyByGZTN1Y87VFrF5ZrXRsg1q_TvWbRhzzE";
export const MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY || "";
// Verejná doména sledovacej stránky objednávky (Order Tracking) podľa prostredia:
//   production → prod, inak (staging/dev) → staging.
// Dá sa prepísať explicitne cez REACT_APP_ORDER_TRACKING_URL.
// URL: {ORDER_TRACKING_URL}/order/{externalOrderId}
const orderTrackingUrlByEnv = () => {
  const env = String(process.env.REACT_APP_ENVIRONMENT || "").toLowerCase();
  return env === "prod" || env === "production"
    ? "https://dsok-notifications.web.app"
    : "https://dsok-notifications-staging.web.app";
};
export const ORDER_TRACKING_URL = (
  process.env.REACT_APP_ORDER_TRACKING_URL || orderTrackingUrlByEnv()
).replace(/\/+$/, "");
export const axios = baseAxios.create({
  baseURL: `${BE_URL}/V1/`,
  headers: {
    "Content-Type": "application/json",
  },
});
